import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import PageHero from "../components/PageHero";
import { SERVICES, COMPANY } from "../mock/mock";

const Services = () => {
  return (
    <div>
      <PageHero
        title="Services"
        subtitle="Des solutions concrètes en gouvernance TI, agilité et gestion de projet."
        image="https://images.unsplash.com/photo-1531403009284-440f080d1e12?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
      />

      {/* Quick nav */}
      <section className="bg-white border-b border-slate-100 sticky top-[78px] z-30 hidden md:block">
        <div className="max-w-7xl mx-auto px-4 md:px-6 flex flex-wrap items-center justify-center gap-x-8 gap-y-2 py-4">
          {SERVICES.map((s) => (
            <a key={s.id} href={`#${s.id}`} className="text-[13px] font-semibold uppercase tracking-wide text-[#15324f] hover:text-[#2f80c4] transition-colors" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              {s.short}
            </a>
          ))}
        </div>
      </section>

      {SERVICES.map((s, idx) => (
        <section key={s.id} id={s.id} className={`scroll-mt-[150px] py-20 ${idx % 2 === 0 ? "bg-white" : "bg-[#f4f6f9]"}`}>
          <div className="max-w-7xl mx-auto px-4 md:px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className={idx % 2 === 1 ? "lg:order-2" : ""}>
              <img src={s.image} alt={s.title} className="rounded-lg shadow-xl w-full h-[360px] object-cover" />
            </div>
            <div className={idx % 2 === 1 ? "lg:order-1" : ""}>
              <span className="text-[#2f80c4] text-sm font-bold uppercase tracking-[0.18em]" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Service {String(idx + 1).padStart(2, "0")}
              </span>
              <h2 className="text-2xl md:text-3xl font-bold text-[#15324f] mt-3 mb-5" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                {s.title}
              </h2>
              <p className="text-slate-600 leading-relaxed mb-6">{s.excerpt}</p>
              <ul className="space-y-3">
                {s.details.map((d) => (
                  <li key={d} className="flex items-start gap-3">
                    <CheckCircle2 size={20} className="text-[#2f80c4] mt-0.5 shrink-0" />
                    <span className="text-slate-600">{d}</span>
                  </li>
                ))}
              </ul>
              <Link to="/nous-joindre" className="mt-8 inline-flex items-center gap-2 bg-[#15324f] text-white px-6 py-3 text-[13px] font-semibold uppercase tracking-wide rounded hover:bg-[#2f80c4] transition-colors duration-300" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Demander de l'information <ArrowRight size={15} />
              </Link>
            </div>
          </div>
        </section>
      ))}

      <section className="bg-[#15324f] py-16">
        <div className="max-w-5xl mx-auto px-4 md:px-6 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Un projet en gouvernance TI ou en agilité ?
          </h2>
          <p className="text-white/75 mb-8">Parlons-en. {COMPANY.phone}</p>
          <Link to="/nous-joindre" className="inline-flex items-center gap-2 bg-[#2f80c4] text-white px-8 py-4 text-sm font-semibold uppercase tracking-wide rounded hover:bg-white hover:text-[#15324f] transition-colors duration-300" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Nous joindre <ArrowRight size={16} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Services;
